import { render, staticRenderFns } from "./AddTaxGroupPage.vue?vue&type=template&id=2ff9ec7a"
import script from "./AddTaxGroupPage.vue?vue&type=script&lang=js"
export * from "./AddTaxGroupPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports